import { LEVELS_TO_UNLOCK_FEATURES, AD_TYPES } from '~/lib/constants';
import { levelSelectors, turnSelectors } from '~/store/selectors';
// ---- local imports ------

function _isAdEndingThisMonth(state, runningAd) {
	return Date.parse(turnSelectors.getTurnDate(state)) === Date.parse(runningAd.endDate);
};

function sortAdsByNewestFirst(ads) {
	return ads.sort((a, b) => a.id < b.id ? 1 : -1);
}

function getAdsAvailableAds(state) {
	return state.ads.availableAds;
}

function getAdsAvailableForCurrentLevel(state) {
	const level = levelSelectors.getLevelNumber(state);

	const availableAds = getAdsAvailableAds(state);

	return availableAds.filter((ad) => {
		switch(ad.type) {
		case AD_TYPES.MAGAZINE:
			return level >= LEVELS_TO_UNLOCK_FEATURES.MAGAZINE_ADS;
		case AD_TYPES.RADIO:
			return level >= LEVELS_TO_UNLOCK_FEATURES.RADIO_ADS;
		case AD_TYPES.BANNER:
			return level >= LEVELS_TO_UNLOCK_FEATURES.BANNER_ADS;
		case AD_TYPES.NEWSPAPER:
			return level >= LEVELS_TO_UNLOCK_FEATURES.NEWSPAPER_ADS;
		default:
			return false;
		}
	});
}

export function getRunningAds(state) {
	return state.ads.boughtAds.filter((ad) => ad.running);
}

export function getBoughtAds(state) {
	return sortAdsByNewestFirst([...state.ads.boughtAds]);
}

export function getAdsAvailableForRent(state) {
	const adsRunningThisMonthIds = state.ads.boughtAds
		.filter((ad) => _isAdEndingThisMonth(state, ad) || ad.running)
		.map((ad) => ad.adId);
	const availableAdsBasedOnLevels = getAdsAvailableForCurrentLevel(state);
	return availableAdsBasedOnLevels.filter((ad) => !adsRunningThisMonthIds.includes(ad.id));
}

export function getHasHiredNewAd(state) {
	return state.ads.hasHiredNewAd;
}

export function getNewAdsRent(state) {
	return state.ads.newAdsRent;
}

export function getNewlyHiredAdStatus(state) {
	return state.ads.isHireAdSuccessful;
}

export function getRunningAdsRent(state) {
	return state.ads.boughtAds
		.filter((ad) => ad.running)
		.reduce((totalRent, ad) => totalRent + ad.price, 0);
}

export function getNextMonthRunningAdsRent(state) {
	return state.ads.boughtAds
		.filter((ad) => ad.endDate === '...')	//	Don't like having string is end date, needs to be fixed in the backend
		.reduce((totalRent, ad) => totalRent + ad.price, 0);
}
